<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
let customerId = window.localStorage.getItem("customerId")
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "supplier",
      key: "id",
      kv: "",
      url: {},
      items: [
        {
          label: Number(customerId) == 0 ? '客户' : '供应商',
          name: "serviceId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: Number(customerId) == 0 ? '客户不能为空' : '供应商不能为空',
              trigger: "blur",
              type: "number",
            },
          ],
          selected: 0,
        },
      ],
      forms: {},
    };
  },
  created() {
    this.loaduserData();
  },
  mounted() {},
  methods: {
    //查询维修员
    async loaduserData() {
      let res = await $utils.api.load("/admin/system/supplier/list", {}, "get");
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.supplierName;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "serviceId") {
            this.items[index]["dropList"] = (this.items[index]["dropList"] || []).concat(
              dropList
            );
          }
        }
      }
    },
    handleSubmit() {
      let id = window.localStorage.getItem("projectId");
      let arr = [];
      let q = {};
      q.projectId = Number(id);
      q.supplierId = this.forms.serviceId;
      arr.push(q);
      this.$refs.form.validate((valid) => {
        if (valid) {
          $utils.api
            .load(`/admin/system/relationship`, arr, "POST")
            .then((res) => {
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$emit("onCancel"); //保存后关闭弹窗
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            });
        }
      });
    },
  },
};
</script>
